import { SEASON_BY_ID, type SeasonId } from '@somnhold/content';
import { seasonAt, seasonOf } from '@somnhold/sim';

/*
 * The holiday season as the client sees it. Normally the real date decides (seasonAt); for testing the
 * looks, `?season=none` forces an ordinary day and `?season=halloween` forces a holiday. The override only
 * touches what this client creates and shows on its own (practice, the menu backdrop, the bastion board,
 * the look of any battle); campaign battles the server re-simulates keep the real season.
 */
const forced = ((): SeasonId | null | undefined => {
  // Also loaded headless (the balance tool builds practice battles): no location there.
  const loc = (globalThis as { location?: { search: string } }).location;
  const q = loc ? new URLSearchParams(loc.search).get('season') : null;
  if (q === 'none') return null;
  return q && q in SEASON_BY_ID ? (q as SeasonId) : undefined;
})();

/** The season now, or null on an ordinary day. */
export const seasonNow = (ms: number): SeasonId | null => (forced === undefined ? seasonAt(ms) : forced);

/** Battle params for a battle this client creates on its own. */
export const localSeason = (ms: number): { season?: SeasonId } => {
  if (forced === undefined) return seasonOf(ms);
  return forced ? { season: forced } : {};
};

/** The look a battle is drawn with: its own season, unless overridden for testing. */
export const viewSeason = (s: SeasonId | undefined): { season?: SeasonId } => {
  const id = forced === undefined ? s : (forced ?? undefined);
  return id ? { season: id } : {};
};
